import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import NotificationAdd from './../../elements/notifications/widget/notification_type_add';

class Notifications extends Component {
	render() {
		let { notifications_types } = this.props;
		let nu = false;
		let nd = false;
		_.find(notifications_types.permissions, (o) => {
			if(o === 'Update') {nu = true;}
			if(o === 'Delete') {nd = true;}
		});
		return (
			<div>
			{notifications_types.isFetching ? <Loading /> :
				<table className={`inm-table`}>
					<thead>
					<tr>
						<th>ID</th>
						<th>Nombre</th>
						<th>Estatus</th>
					</tr>
					</thead>
					<tbody>
					{_.map(notifications_types.list, (row, k) => {
						return (
							<tr key={k}>
								<td style={{width:'80px'}}>
									<div className="actions">
										{nu ? <NavLink to={`/notificaciones/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
										{nd ? <button onClick={() => this._getConfirm(row.id,row.name)}><i className="fa fa-trash-o"></i></button>:''}
									</div>
									{row.id}
								</td>
								<td>{row.name}</td>
								<td>
									<strong className={`has-text-${row.status.style}`}>{row.status.name}</strong>
								</td>
							</tr>
						)
					})}
					</tbody>
				</table>}
			{notifications_types.pages.total>20 &&
			<InmPagination
				key="concepts-pages"
				current={notifications_types.pages.current}
				total={notifications_types.pages.total}
				nextPage={this._handlePageChange}
			/>}
		</div>
		)
	}

	componentWillMount() {
		this.props.fetchNotificationsTypes(this.props.notifications_types.pages.current);
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		this.props.fetchGroupsPhasesShow(value);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la notificación "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.groupPhaseDelete(id)
		})
	}
}

export default BaseLayout(Notifications, {
	title:"Administrar notificaciones",
	subnav: {
		icon: 'fa-sliders',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <NotificationAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/notifications/index.jsx